import React, { useState } from "react";
import "./SignIn.css";
import { Link, useHistory, Redirect } from "react-router-dom";
import amazonwhite from "./Assets/amazonwhite.jpg";
import { auth } from "./firebase";
const SignIn = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const history = useHistory();
  const signInHandler = (e) => {
    e.preventDefault();
    auth
      .signInWithEmailAndPassword(email, password)
      .then((auth) => {
        history.push("/");
      })
      .catch((err) => {
        alert(err);
      });
  };
  const registerHandler = (e) => {
    auth
      .createUserWithEmailAndPassword(email, password)
      .then((auth) => {
        if (auth) {
          history.push("/");
        }
      })
      .catch((error) => {
        alert(error);
      });
    e.preventDefault();
  };
  return (
    <div className="signin">
      <Link to="/">
        <img className="signin_image" src={amazonwhite}></img>
      </Link>
      <div className="signin_box">
        <h2 className="signin_heading">Sign-In</h2>
        <form className="signin_form">
          <p>Email</p>
          <input
            type="text"
            value={email}
            onChange={(event) => {
              setEmail(event.target.value);
            }}
          ></input>
          <p>Password</p>
          <input
            type="password"
            value={password}
            onChange={(event) => {
              setPassword(event.target.value);
            }}
          ></input>
          <button type="submit" onClick={signInHandler}>
            {" "}
            Sign-In{" "}
          </button>
        </form>
        <small className="signin_condition">
          <b>
            Please read these conditions carefully before using the Amazon.in
            website. By using the Amazon.in website, you signify your agreement
            to be bound by these conditions.
          </b>
        </small>
        <button onClick={registerHandler}>Create Your Amazon Account</button>
      </div>
    </div>
  );
};
export default SignIn;
